import React from 'react'
import { AdminContainer } from '../'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import { UsageLimitContainer } from 'organisms/UsageLimit/container'

export default function Usage() {
  return (
    <React.Fragment>
      <PageHeaderContainer title="Usage" />
      <AdminContainer>
        <div className="ui segment admin-section">
          <UsageLimitContainer />
        </div>
      </AdminContainer>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Usage/index.js